module.exports = __webpack_public_path__ + "static/antd-card-meta-8d21751b85f4c6a052e02308db6616e9.png";